import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Column } from 'react-data-grid';
import { Header, Icon } from 'semantic-ui-react';
import { ContainerProps } from 'src/shared/typemap';
import DataGrid from 'src/components/generic/GenericOperatableStoreDataGrid';
import { Identifiable, DataClass, Reducable, reduce } from 'src/shared/utility';
import { AuthStore } from 'src/stores/authStore';
import './Container.scss';

interface EditorProps {
    resolveRow: any;
    rejectRow: any;
    fromObject: any;
    isNew: boolean;
}

export default function ContainerGenerator<S, C, Interfaced extends Identifiable, Class extends DataClass> 
(
    columns: Reducable<Array<Column>>,
    dataStore: string,
    EditorClass: (props: EditorProps) => JSX.Element,
    authProperty: (props: AuthStore) => any,
    defaultValue?: (props: AuthStore) => any,
    preProcess?: (input: any) => any
) {
    class RenderableDataGrid extends DataGrid< Interfaced, Class > {}
    return inject('authStore', 'routing', dataStore) ( observer( 
        class GenericContainer extends React.Component<any & ContainerProps, any> {
            resolve?: (data: any) => any;
            reject?: (err: any) => any;
            
            constructor(props: any) {
              super(props);
              this.state = {};
            }
            
            edit(editObj: any, isNew?: boolean) {
              let me = this;
              return new Promise((res, rej) => {
                me.resolve = res;
                me.reject = rej;

                this.setState(
                    {
                        currentEdit: editObj,
                        isNew
                    }
                );
              });
            }

            render() {
                const { 
                    name,
                    icon,
                    enableFilter,
                    enableAddRow,
                    enableDeleteRow,
                    addRowButtonText,
                    filterRowsButtonText
                } = authProperty(this.props.authStore);
                const _columns = reduce(columns, this.props.authStore);
                return (
                    <div className="App">
                    <div className="header">
                        <Header as="h3" icon textAlign="center">
                        <Icon name={icon} circular />
                        <Header.Content>
                            {name}
                        </Header.Content>
                        </Header>
                    </div>
                    <RenderableDataGrid
                        toolBarOptions={{
                            enableFilter,
                            enableAddRow,
                            enableDeleteRow,
                            addRowButtonText,
                            filterRowsButtonText
                        }}
                        rowHeight={66}
                        columns={_columns}  
                        defaultValue={defaultValue.bind(this, this.props.authStore)}
                        dataStore={this.props[dataStore]}
                        lazyLoad={true}
                        editRow={this.edit.bind(this)}
                        preProcess={preProcess}
                        {...this.props as ContainerProps}
                    />
                    {this.state.currentEdit ? this.renderEdit() : null}
                    </div>
                );
            }
          
            renderEdit() {
              return (
                <EditorClass  
                    resolveRow={this.resolveRow.bind(this)}
                    rejectRow={this.rejectRow.bind(this)}
                    fromObject={this.state.currentEdit}
                    isNew={this.state.isNew}
                />
              );
            }
          
            private resolveRow(resolvedData: any) {
              this.setState({
                currentEdit: undefined
              });
              this.resolve(resolvedData);
            }
          
            private rejectRow(Err?: any) {
              this.setState({
                currentEdit: undefined
              });
              this.reject(Err);
            }
        } 
    ) );
}
    


// WEBPACK FOOTER //
// ./src/container/Generic/Container.tsx